import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const EmailSentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const ResendCode = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.500"],
    alignSelf: "center",
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
}));
